module.exports = __webpack_public_path__ + "img/arrow-w.cc256c9e.svg";